import { render, staticRenderFns } from "./SuggestedItemSkuSection.vue?vue&type=template&id=8db75ffc&scoped=true&"
import script from "./SuggestedItemSkuSection.vue?vue&type=script&lang=js&"
export * from "./SuggestedItemSkuSection.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedItemSkuSection.vue?vue&type=style&index=0&id=8db75ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db75ffc",
  null
  
)

export default component.exports